import { Tabs } from "radix-ui";
import { cn } from "../../../helpers/utils";

const TabsList = ({ children, isSub }) => (
  <Tabs.List
    className={cn(
      "flex w-full",
      isSub
        ? "rounded-md border border-gray-200 bg-gray-100 p-1"
        : "flex justify-center border-b border-gray-300 mb-4"
    )}
  >
    {children}
  </Tabs.List>
);

export default TabsList;
